exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnchorLinkButtons1 .link-buttons{border-width:1px;border-style:none solid solid none}.AnchorLinkButtons1 .link-button{border-width:1px;border-style:solid none none solid;outline:none;cursor:pointer}.AnchorLinkButtons1 .link-button>.anchor{font-size:1.3em}.AnchorLinkButtons1 .link-button>.before{display:block;font-size:1em}.AnchorLinkButtons1 .link-button:hover>.before{color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/AnchorLinkButtons1/AnchorLinkButtons1.scss
// module id = 882
// module chunks = 36